import { render, staticRenderFns } from "./AccidentIntakeMedicalSurgicalHistoryForm.vue?vue&type=template&id=004ac8f0&scoped=true"
import script from "./AccidentIntakeMedicalSurgicalHistoryForm.vue?vue&type=script&lang=js"
export * from "./AccidentIntakeMedicalSurgicalHistoryForm.vue?vue&type=script&lang=js"
import style0 from "./AccidentIntakeMedicalSurgicalHistoryForm.vue?vue&type=style&index=0&id=004ac8f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004ac8f0",
  null
  
)

export default component.exports